import styled from '@emotion/styled'
import theme from '../../styles/theme'

export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  gap: 2.5rem;
`

export const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  flex: 1;
  max-width: 22rem;
`

export const FooterText = styled.p`
  margin: 0;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.55;
  color: ${theme.colors.veryVeryFadedText};
`

export const FooterLink = styled.a`
  color: ${theme.colors.brand};
  font-weight: 500;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`

export const FooterBrand = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding-top: 0.15rem;

  img {
    width: 100px;
    opacity: 0.88;
  }
`
